/* eslint-disable no-bitwise */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-mixed-operators */
// @ts-nocheck
// https://github.com/joshjg/react-canvas-knob
import React from 'react';

type KnobProps = {
  value: number | string;
  onChange: Function;
  onChangeEnd?: Function;
  min?: number;
  max?: number;
  step?: number;
  log?: boolean;
  width?: number;
  height?: number;
  thickness?: number;
  lineCap?: 'butt' | 'round';
  bgColor?: string;
  fgColor?: string;
  inputColor?: string;
  font?: string;
  fontWeight?: string;
  clockwise?: boolean;
  cursor?: number | boolean;
  readOnly?: boolean;
  disableTextInput?: boolean;
  displayInput?: boolean;
  displayCustom?: Function;
  angleArc?: number;
  angleOffset?: number;
  disableMouseWheel?: boolean;
  title?: string;
  className?: string;
  canvasClassName?: string;
};

class Knob extends React.Component<KnobProps> {
  constructor(props: KnobProps) {
    super(props);
    const {
      width,
      height,
      cursor,
      angleArc,
      angleOffset,
      min,
      max,
    } = this.props;
    this.w = width || 200;
    this.h = height || this.w;
    this.cursorExt = cursor === true ? 0.3 : cursor / 100;
    this.angleArc = (angleArc * Math.PI) / 180;
    this.angleOffset = (angleOffset * Math.PI) / 180;
    this.startAngle = (1.5 * Math.PI) + this.angleOffset;
    this.endAngle = (1.5 * Math.PI) + this.angleOffset + this.angleArc;
    this.digits = Math.max(
      String(Math.abs(min)).length,
      String(Math.abs(max)).length,
      2,
    ) + 2;
  }

  componentDidMount() {
    this.drawCanvas();
    const { readOnly } = this.props;
    if (!readOnly) {
      this.canvasRef.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.width && this.w !== nextProps.width) {
      this.w = nextProps.width;
    }
    if (nextProps.height && this.h !== nextProps.height) {
      this.h = nextProps.height;
    }
  }

  componentDidUpdate() {
    this.drawCanvas();
  }

  componentWillUnmount() {
    this.canvasRef.removeEventListener('touchstart', this.handleTouchStart);
  }

  getArcToValue = (v) => {
    let startAngle;
    let endAngle;
    const {
      log, min, max,
      clockwise, cursor,
    } = this.props;
    const angle = !log
      ? ((v - min) * this.angleArc) / (max - min)
      : Math.log((v / min) ** this.angleArc) / Math.log(max / min);
    if (!clockwise) {
      startAngle = this.endAngle + 0.00001;
      endAngle = startAngle - angle - 0.00001;
    } else {
      startAngle = this.startAngle - 0.00001;
      endAngle = startAngle + angle + 0.00001;
    }
    if (cursor) {
      startAngle = endAngle - this.cursorExt;
      endAngle += this.cursorExt;
    }
    return {
      startAngle,
      endAngle,
      acw: !clockwise && !cursor,
    };
  };

  // Calculate ratio to scale canvas to avoid blurriness on HiDPI devices
  // eslint-disable-next-line class-methods-use-this
  getCanvasScale = (ctx) => {
    const devicePixelRatio = window.devicePixelRatio
      || window.screen.deviceXDPI / window.screen.logicalXDPI // IE10
      || 1;
    const backingStoreRatio = ctx.webkitBackingStorePixelRatio || 1;
    return devicePixelRatio / backingStoreRatio;
  };

  coerceToStep = (v) => {
    const {
      log, min, max, step,
    } = this.props;
    let val = !log
      ? (~~(((v < 0) ? -0.5 : 0.5) + (v / step))) * step
      : step ** ~~(((Math.abs(v) < 1) ? -0.5 : 0.5) + (Math.log(v) / Math.log(step)));
    val = Math.max(Math.min(val, max), min);
    if (Number.isNaN(val)) { val = 0; }
    return Math.round(val * 1000) / 1000;
  };

  eventToValue = (e) => {
    const bounds = this.canvasRef.getBoundingClientRect();
    const x = e.clientX - bounds.left;
    const y = e.clientY - bounds.top;
    let a = Math.atan2(x - (this.w / 2), (this.w / 2) - y) - this.angleOffset;
    const { clockwise, min, max } = this.props;
    if (!clockwise) {
      a = this.angleArc - a - (2 * Math.PI);
    }
    if (this.angleArc !== Math.PI * 2 && (a < 0) && (a > -0.5)) {
      a = 0;
    } else if (a < 0) {
      a += Math.PI * 2;
    }
    const val = !log
      ? ((a * (max - min)) / this.angleArc) + min
      : (max / min) ** (a / this.angleArc) * min;
    return this.coerceToStep(val);
  };

  handleMouseDown = (e) => {
    const { onChange } = this.props;
    onChange(this.eventToValue(e));
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
    document.addEventListener('keyup', this.handleEsc);
  };

  handleMouseMove = (e) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(this.eventToValue(e));
  };

  handleMouseUp = (e) => {
    const { onChangeEnd } = this.props;
    onChangeEnd(this.eventToValue(e));
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('keyup', this.handleEsc);
  };

  handleTouchStart = (e) => {
    const { onChange } = this.props;
    e.preventDefault();
    this.touchIndex = e.targetTouches.length - 1;
    onChange(this.eventToValue(e.targetTouches[this.touchIndex]));
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    document.addEventListener('touchend', this.handleTouchEnd);
    document.addEventListener('touchcancel', this.handleTouchEnd);
  };

  handleTouchMove = (e) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(this.eventToValue(e.targetTouches[this.touchIndex]));
  };

  handleTouchEnd = (e) => {
    const { onChangeEnd } = this.props;
    onChangeEnd(this.eventToValue(e));
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.removeEventListener('touchend', this.handleTouchEnd);
    document.removeEventListener('touchcancel', this.handleTouchEnd);
  };

  handleEsc = (e) => {
    if (e.keyCode === 27) {
      e.preventDefault();
      this.handleMouseUp();
    }
  };

  handleTextInput = (e) => {
    const { onChange, min, max } = this.props;
    const val = Math.max(Math.min(+e.target.value, max), min) || min;
    onChange(val);
  };

  handleWheel = (e) => {
    const {
      onChange, value, step, log,
    } = this.props;
    e.preventDefault();
    if (e.deltaX > 0 || e.deltaY > 0) {
      onChange(this.coerceToStep(
        !log
          ? value + step
          : value * step,
      ));
    } else if (e.deltaX < 0 || e.deltaY < 0) {
      onChange(this.coerceToStep(
        !log
          ? value - step
          : value / step,
      ));
    }
  };

  handleArrowKey = (e) => {
    const {
      onChange, value, step, log,
    } = this.props;
    if (e.keyCode === 37 || e.keyCode === 40) {
      e.preventDefault();
      onChange(this.coerceToStep(
        !log
          ? value - step
          : value / step,
      ));
    } else if (e.keyCode === 38 || e.keyCode === 39) {
      e.preventDefault();
      onChange(this.coerceToStep(
        !log
          ? value + step
          : value * step,
      ));
    }
  };

  inputStyle = () => ({
    width: `${((this.w / 2) + 4) >> 0}px`,
    height: `${(this.w / 3) >> 0}px`,
    position: 'absolute',
    verticalAlign: 'middle',
    marginTop: `${(this.w / 3) >> 0}px`,
    marginLeft: `-${((this.w * 3 / 4) + 2) >> 0}px`,
    border: 0,
    background: 'none',
    font: `${this.props.fontWeight} ${(this.w / this.digits) >> 0}px ${this.props.font}`,
    textAlign: 'center',
    color: this.props.inputColor || this.props.fgColor,
    padding: '0px',
    WebkitAppearance: 'none',
  });

  drawCanvas() {
    const ctx = this.canvasRef.getContext('2d');
    const scale = this.getCanvasScale(ctx);
    this.canvasRef.width = this.w * scale; // clears the canvas
    this.canvasRef.height = this.h * scale;
    ctx.scale(scale, scale);
    this.xy = this.w / 2; // coordinates of canvas center
    this.lineWidth = this.xy * this.props.thickness;
    this.radius = this.xy - (this.lineWidth / 2);
    ctx.lineWidth = this.lineWidth;
    ctx.lineCap = this.props.lineCap;
    // background arc
    ctx.beginPath();
    ctx.strokeStyle = this.props.bgColor;
    ctx.arc(
      this.xy,
      this.xy,
      this.radius,
      this.endAngle - 0.00001,
      this.startAngle + 0.00001,
      true,
    );
    ctx.stroke();
    // foreground arc
    const a = this.getArcToValue(this.props.value);
    ctx.beginPath();
    ctx.strokeStyle = this.props.fgColor;
    ctx.arc(
      this.xy,
      this.xy,
      this.radius,
      a.startAngle,
      a.endAngle,
      a.acw,
    );
    ctx.stroke();
  }

  renderCenter = () => {
    const {
      displayCustom,
      displayInput,
      disableTextInput,
      readOnly,
      value,
    } = this.props;

    if (displayInput) {
      return (
        <input
          style={this.inputStyle()}
          type="text"
          value={value}
          onChange={this.handleTextInput}
          onKeyDown={this.handleArrowKey}
          readOnly={readOnly || disableTextInput}
        />
      );
    } if (displayCustom && typeof displayCustom === 'function') {
      return displayCustom();
    }
    return null;
  };

  render() {
    const {
      canvasClassName,
      className,
      disableMouseWheel,
      readOnly,
      title,
      value,
    } = this.props;

    return (
      <div
        className={className}
        style={{ width: this.w, height: this.h, display: 'inline-block' }}
        onWheel={readOnly || disableMouseWheel ? null : this.handleWheel}
      >
        <canvas
          ref={(ref) => { this.canvasRef = ref; }}
          className={canvasClassName}
          style={{ width: '100%', height: '100%' }}
          onMouseDown={readOnly ? null : this.handleMouseDown}
          title={title ? `${title}: ${value}` : value}
        />
        {this.renderCenter()}
      </div>
    );
  }
}

Knob.defaultProps = {
  onChangeEnd: () => {},
  min: 0,
  max: 100,
  step: 1,
  log: false,
  width: 200,
  height: 200,
  thickness: 0.35,
  lineCap: 'butt',
  bgColor: '#EEE',
  fgColor: '#EA2',
  inputColor: '',
  font: 'Arial',
  fontWeight: 'bold',
  clockwise: true,
  cursor: false,
  readOnly: false,
  disableTextInput: false,
  displayInput: true,
  angleArc: 360,
  angleOffset: 0,
  disableMouseWheel: false,
  className: null,
  canvasClassName: null,
};

export default Knob;
